<template>
	<div class="main-modal" v-on:click="onClickModal">
        <div class="main-modal--container" v-bind:class="stretch ? 'w-100' : ''">
            <div class="main-modal--container-header" v-bind:class="left_title ? 'left-title' : ''">
                <div class="d-flex" v-if="subtitle">
                    <h5 class="d-block">{{title}}</h5>
                    <h6 v-if="subtitle" class="d-block">{{title ? ', ' + subtitle : subtitle}}</h6>
                </div>
                <div class="d-flex" v-else>
                    <h5 class="d-block">{{title}}</h5>
                </div>
                <svg-image
                    :src="'/svg/' + resource_group + '/close.svg'"
                    class="main-modal--container-header-close"
                    color="inactive"
                    v-on:click="closeModal(null, true)"
                    :auto_hover="true"
                ></svg-image>
            </div>
            <div class="main-modal--container-body" v-bind:class="no_overflow ? 'no-overflow' : ''">
                 <slot></slot> 
            </div>
            <div class="main-modal--container-footer d-flex align-items-center">
                <slot name="footer"></slot>  
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Modal",
        props: {
			title: {
				type: String,
				default: ''
            },
            subtitle: {
			    type: String,
                default: null
            },
            close_on_focus: {
				type: Boolean,
                default: false
            },
            no_overflow: {
				type: Boolean,
                default: false
            },
            left_title: {
			    type: Boolean,
                default: false
            },
			stretch: {
				type: Boolean,
				default: false
			}
		},

        mounted() {
			this.$on('close-modal-child', function (){
				this.closeModal(null, true);
            });
        },

        methods: {
			closeModal(e, force = false){
				if (!force){
					if ($(e.target).closest('.main-modal--container').length){
						return;
					}
				}

				this.$emit('close-modal');
				window.closeModal(this.$el);
			},

            openModal(){
				window.openModal($(this.$el));
            },

            onClickModal(event){
				if (this.close_on_focus) this.closeModal(event);
            }
        }

	}
</script>
